import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_PERIOD_LOCK } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import PeriodLockSetting from '../../components/PeriodLock/PeriodLockSetting';

export const Route = createFileRoute('/_authenticated/period-lock/definition/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PERIOD_LOCK, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'periodLock.addSetting',
        suffix: 'menu.periodLock',
      },
    };
  },
  // Modal opened by the PeriodLockSetting list based on the URL.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <PeriodLockSetting />;
}
